import React from 'react';

import type { ActiveStateOverrider } from '@/js/libs/ui';
import { SubHeader } from '@/js/libs/ui';

export interface NavItemProps {
  to: string;
  dataTestId?: string;
  label: string;
  getOverriddenActive?: ActiveStateOverrider;
}

const NavItem = ({ to, label, dataTestId, getOverriddenActive }: NavItemProps) => (
  <SubHeader.NavItem to={to} dataTestId={dataTestId} getOverriddenActive={getOverriddenActive}>
    {label}
  </SubHeader.NavItem>
);

NavItem.displayName = 'NavItem';

export default React.memo(NavItem);
